<section class="dashboard-container shadow-lg rounded-4 p-4 bg-white">
  <h3 *ngIf="direction == 'ltr'"><span>{{ "Admin" | translate }}</span> {{ "Dashboard" | translate }}</h3>
  <h3 *ngIf="direction == 'rtl'">{{ "Dashboard" | translate }} <span>{{ "Admin" | translate }}</span></h3>

  <label for="editor" class="form-label mb-2">{{ "Edit Content" | translate }}:</label>
  <div id="editor" class="quill-editor rounded shadow-sm border"></div>

  <label for="imageUpload" class="form-label mt-4">{{ "Upload Image" | translate }}:</label>
  <input
    type="file"
    id="imageUpload"
    (change)="onFileChange($event)"
    class="form-control file-input"
  />

  <div class="mt-4">
    <button
      (click)="submit()"
      [disabled]="uploading"
      class="btn btn-primary submit-btn"
    >
      <i class="bi bi-upload me-1"></i>
      {{ uploading ? "Uploading..." : "Submit" | translate }}
    </button>
  </div>

  <p class="status mt-3" *ngIf="message">{{ message }}</p>

  <div *ngIf="imageUrl" class="mt-4 text-center">
    <button
      type="button"
      class="btn btn-primary submit-btn"
      (click)="openImage()"
    >
        {{ "Preview Image" | translate }}
    </button>
  </div>
</section>
